export default __webpack_public_path__ + "static/media/infinity.99586299.svg";